import React, { useState, useEffect } from 'react';

export default function Confirmation({ participant, choix, onModify, onDone }) {
  const [boissons, setBoissons] = useState([]);

  useEffect(() => {
    const boissonIds = Object.keys(choix).map(Number);
    fetch('/api/boissons')
      .then(r => r.json())
      .then(data => setBoissons(data.filter(b => boissonIds.includes(b.id))));
  }, [choix]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <div className="container px-3" style={{ maxWidth: 420 }}>
        <div className="party-card p-4 text-center">
          <div className="success-icon mb-2">🎉</div>
          <h2 style={{ fontWeight: 800, color: '#1a2e35', fontSize: '1.5rem', marginBottom: '0.4rem' }}>
            C'est noté, {participant.nom} !
          </h2>
          <p style={{ color: '#607d8b', fontSize: '0.92rem', marginBottom: '1.5rem' }}>
            À très bientôt le 16 août 🌞
          </p>

          {/* Récap boissons */}
          <div style={{ background: '#f0f9fb', borderRadius: '1rem', padding: '1rem', marginBottom: '1.5rem', textAlign: 'left' }}>
            <div style={{ fontWeight: 800, color: '#006064', fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.6rem' }}>
              Tu apportes :
            </div>
            {boissons.length === 0 ? (
              <div style={{ color: '#90a4ae', fontSize: '0.88rem' }}>Chargement...</div>
            ) : (
              boissons.map(b => (
                <div key={b.id} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.3rem 0' }}>
                  <span style={{ fontSize: '1.3rem' }}>{b.emoji}</span>
                  <span style={{ fontWeight: 700, color: '#1a2e35' }}>
                    {b.nom}{choix[b.id] > 1 ? ` ×${choix[b.id]}` : ''}
                  </span>
                  <i className="bi bi-check-circle-fill ms-auto" style={{ color: 'var(--party-success)' }} />
                </div>
              ))
            )}
          </div>

          <button className="btn btn-party w-100 mb-2" onClick={onModify} style={{ background: 'linear-gradient(135deg, #607d8b, #455a64)' }}>
            <i className="bi bi-pencil me-2" />Modifier mes choix
          </button>

          <button className="btn btn-party w-100" onClick={onDone}>
            Ok <i className="bi bi-check-lg ms-1" />
          </button>
        </div>

        <div className="text-center mt-3" style={{ color: '#90a4ae', fontSize: '0.85rem' }}>
          Avec amour — Gladys & Henry 💙
        </div>
      </div>
    </div>
  );
}
